import React, { useState } from 'react'
import { default as TextAreaAutoResize } from 'react-textarea-autosize'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import styles from './TextArea.module.scss'

const TextArea = React.forwardRef(
  ({ className, onFocus, onBlur, ...restProps }, ref) => {
    const [mouseFocused, setMouseFocused] = useState(false)
    const [moused, setMoused] = useState(false)

    const captureMouse = () => {
      setMoused(true)
      window.addEventListener('mouseup', () => setMoused(false))
    }

    return (
      <div
        className={classnames(
          styles.root,
          mouseFocused && styles.focused,
          className
        )}
        data-qa="text-area-input-wrapper"
      >
        <TextAreaAutoResize
          className={styles.input}
          onMouseDown={captureMouse}
          onFocus={(e) => {
            setMouseFocused(moused)
            if (onFocus) onFocus(e)
          }}
          onBlur={(e) => {
            setMouseFocused(false)
            if (onBlur) onBlur(e)
          }}
          ref={ref}
          {...restProps}
        />
      </div>
    )
  }
)

TextArea.propTypes = {
  className: PropTypes.string,
  type: PropTypes.string,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
}
TextArea.displayName = 'TextArea'

export default TextArea
